import { getTrackingData, writeTrackingData } from '../cookie/tracking-cookie.js';
import { categorizePage, type PageCategory } from './categorization.js';
import { slimUrl } from '../attribution/url-slim.js';
import { logger } from '../utils/logger.js';

/**
 * Incrémente les compteurs de page views dans le cookie selon la catégorie
 * de la page courante. Appelé une fois par page load.
 *
 * - Toutes les pages incrémentent `page_view_session_totale`
 * - Les thank you pages ne sont PAS comptées dans les compteurs par catégorie
 * - `firstpage_view` est enregistré une seule fois (première visite)
 */
export function incrementPageViews(): void {
  const data = getTrackingData();
  const category = categorizePage();

  // Premier page view enregistré dans firstpage_view (une seule fois)
  if (!data.firstpage_view) {
    data.firstpage_view = slimUrl(window.location.href);
  }

  // Compteur total (toutes pages, y compris thank you)
  data.page_view_session_totale = (data.page_view_session_totale ?? 0) + 1;

  // Compteur par catégorie (hors thank you)
  if (category !== 'thank-you') {
    const key = getCounterKey(category);
    data[key] = (data[key] ?? 0) + 1;
  }

  writeTrackingData(data);
  logger.info('Page view comptabilisé:', category);
}

function getCounterKey(
  category: Exclude<PageCategory, 'thank-you'>,
): 'page_view_session_public' | 'page_view_session_blog' | 'page_view_session_dashboard' {
  switch (category) {
    case 'blog': return 'page_view_session_blog';
    case 'dashboard': return 'page_view_session_dashboard';
    case 'public': return 'page_view_session_public';
  }
}
